<div>
  <a class="link helvetica-neue-regular-font cancel-link vo-secondary-button-1"
    [boiPermissionChecker]="[userPermissions.EditIncompleteApp, userPermissions.EditApp]"
    (click)="refreshApplication(); cancel.emit();" [innerHTML]="referenceDataLabels.CancelId | localizeLabel"></a>
</div>

<ng-container *ngIf="isActionVisible">
  <button [disabled]="isFieldDisabled" (click)="saveApplication()" class="primary-button vo-primary-button-1"
    [innerHTML]="saveButtonLabel | localizeLabel">
  </button>
</ng-container>